import axios from "./axios";

const buildUrl = function(module, url) {
  const config = window.config;
  switch (module) {
    case "basic":
      return config.basicServerUrl + url;
    case "maint":
      return config.maintServerUrl + url;
    case "repair":
      return config.repairServerUrl + url;
    default:
      throw "未知模块名称：" + module;
  }
};

export default {
  /**
   * Get方法获取数据
   * get(String url,Object params) 示例get('users',{pageNum:1})
   */
  get: (module, url, params, headers, timeout) => {
    return axios({
      url: buildUrl(module, url),
      method: "get",
      params: params,
      headers: headers,
      timeout: timeout,
    });
  },

  exportFile: function(module, url, params, timeout) {
    return axios({
      timeout: timeout,
      url: buildUrl(module, url),
      method: "get",
      params: params,
      responseType: "blob",
    });
  },

  postForFile: (module, url, data, params, timeout) => {
    return axios({
      timeout: timeout,
      url: buildUrl(module, url),
      method: "post",
      data: data,
      params: params,
      responseType: "blob",
    });
  },
  getForFile: (module, url, data, params, timeout) => {
    return axios({
      timeout: timeout,
      url: buildUrl(module, url),
      method: "get",
      data: data,
      params: params,
      responseType: "blob",
    });
  },

  put: (module, url, data, params) => {
    return axios({
      url: buildUrl(module, url),
      method: "put",
      data: data,
      params: params,
    });
  },

  post: (module, url, data, params) => {
    return axios({
      url: buildUrl(module, url),
      method: "post",
      data: data,
      params: params,
    });
  },

  // 删除,示例delete('users',10)
  delete: (module, url, id) => {
    return axios({
      url: buildUrl(module, url) + "/" + id,
      method: "delete",
    });
  },

  save: (module, url, data) => {
    return axios({
      url: buildUrl(module, url),
      method: (!data.id || data.id === 0) && (!data.pkid || data.pkid === 0) && (!data.pkId || data.pkId === 0) ? "post" : "put",
      data: data,
    });
  },

  saveByPKID: (module, url, data) => {
    return axios({
      url: buildUrl(module, url),
      method: !data.pkid || data.pkid === 0 ? "post" : "put",
      data: data,
    });
  },
  request: (module, config) => {
    config.url = buildUrl(module, config.url);
    return axios(config);
  },

  // 导出表格数据
  exportExcel: (module, url, params,exportColumns, method="get") => {
    return axios({
      url: buildUrl(module, url),
      method,
      params: params,
      responseType: "arraybuffer",
      headers: {
        "Export-Excel": 1,
        "Export-Excel-Include-Columns": exportColumns,
      },
    });
  },
};
